import api from 'services/api/microfwk';
import _ from 'lodash';

export const getRecordingAdd = (params = {}) =>
  api
    .get('/services/recordings/add', { params })
    .then(({ data }) => data)
    .catch(error => {
      const data = _.get(error, 'response.data', false);
      if (data) return data;
      return error;
    });
